import type { AreaSelectBoxProps } from "./types";

export const AreaSelectBox = ({ box }: AreaSelectBoxProps) => {
  if (!box) return null;
  return (
    <div
      data-testid="plan-selection-box"
      className="pointer-events-none absolute z-30 border-2 border-dashed border-blue-500 bg-blue-500/10"
      style={{
        left: Math.min(box.from.x, box.to.x),
        top: Math.min(box.from.y, box.to.y),
        width: Math.abs(box.to.x - box.from.x),
        height: Math.abs(box.to.y - box.from.y),
      }}
    />
  );
};
